import React, { useState, useEffect } from 'react';
import './Footer.css';
import { apiFetch } from './api';

// ISO LocalDate "YYYY-MM-DD" → DD/MM/YYYY (data local, sem fuso).
function formatarData(iso) {
  if (!iso) return '';
  const partes = String(iso).slice(0, 10).split('-');
  if (partes.length !== 3) return iso;
  const [ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
}

function Footer({ onNavegar }) {
  // Última revista publicada (GET /api/revistas/ultima, cacheada 1h no backend).
  // Null até carregar ou se indisponível — nesse caso o rótulo não é exibido.
  const [ultimaRevista, setUltimaRevista] = useState(null);

  const [inpiStatus, setInpiStatus] = useState({
    online: true,
    ultimaVerificacao: new Date()
  });

  const year = new Date().getFullYear();

  const verificarStatusINPI = async () => {
    try {
      const response = await fetch('https://www.inpi.gov.br/');
      const isOnline = response.ok;

      setInpiStatus({
        online: isOnline,
        ultimaVerificacao: new Date()
      });
    } catch (error) {
      setInpiStatus({
        online: false,
        ultimaVerificacao: new Date()
      });
    }
  };

  useEffect(() => {
    verificarStatusINPI();
    const interval = setInterval(verificarStatusINPI, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let ativo = true;
    apiFetch('/api/revistas/ultima')
      .then((dados) => {
        if (ativo && dados) {
          setUltimaRevista({ numero: dados.numero, data: formatarData(dados.data) });
        }
      })
      .catch(() => {
        // sem última revista (ou erro/sessão): não exibe o rótulo
      });
    return () => {
      ativo = false;
    };
  }, []);

  return (
    <footer className="sefira-footer">
      <div className="footer-inner">
        <span className="footer-copyright">
          &copy; {year} Sefira
        </span>
        <div className="footer-meta">
          {ultimaRevista && (
            <span className="footer-revista">
              Revista INPI N.{ultimaRevista.numero} ({ultimaRevista.data})
            </span>
          )}
          <div className="footer-inpi-status">
            <span className={`footer-status-dot ${inpiStatus.online ? 'online' : 'offline'}`} />
            <span className="footer-status-label">
              INPI {inpiStatus.online ? 'Online' : 'Offline'}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
